module.exports = __webpack_public_path__ + "static/media/50.21838245.png";